import { useEffect, useState } from "react";
import { Button, Modal, App, Form } from "antd";
import { BaseButtonProps } from "antd/lib/button/button";
import { ProForm } from "@ant-design/pro-components";
import { Params } from "@/facilities/model/user";
import { useTranslation } from "react-i18next";
import { CloseOutlined } from "@ant-design/icons";

const CustomModal = ({
  children,
  title,
  modalName,
  initValues,
  buttonCogfig,
  okText,
  otherParams = {},
  isProForm = true,
  onShowModal,
  onColseModal,
  request,
  onClick,
  layout = "horizontal",
  width = 680,
  isShowOkButton = true,
  className,
}: {
  children: React.ReactNode;
  title?: string;
  modalName?: string;
  isProForm?: boolean;
  otherParams?: any;
  initValues?: Params;
  okText?: string;
  buttonCogfig?: BaseButtonProps;
  className?: string;
  isShowOkButton?: boolean;
  width?: string | number;
  layout?: "horizontal" | "vertical" | "inline";
  onShowModal?: () => void;
  onColseModal?: () => void;
  request?: (params: any) => Promise<any>;
  onClick?: (obj: any, callBack?: (isOpen: boolean) => void) => void;
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { message } = App.useApp();

  useEffect(() => {
    if (isProForm && open && form) {
      form?.resetFields();
      form?.setFieldsValue(initValues);
    }
  }, [open, initValues, isProForm, form]);
  return (
    <>
      <Button
        color="primary"
        variant="solid"
        {...buttonCogfig}
        onClick={() => {
          setOpen(true);
          onShowModal?.();
        }}
      >
        {title}
      </Button>
      <Modal
        title={<p>{modalName || title}</p>}
        width={width}
        className={`customModalCenxt ${className}`}
        footer={
          <>
            <Button
              type="default"
              variant="outlined"
              onClick={() => {
                if (isProForm) {
                  form?.resetFields();
                }
                setOpen(false);
              }}
            >
              {t("cancel")}
            </Button>
            {isShowOkButton && (
              <Button
                type="primary"
                loading={loading}
                onClick={() => {
                  setLoading(true);
                  if (isProForm) {
                    setLoading(false);
                    form?.submit?.();
                  } else {
                    onClick?.(
                      isProForm ? form?.getFieldsValue() : {},
                      (isOpen) => {
                        setLoading(false);
                        setOpen(isOpen);
                      }
                    );
                  }
                }}
              >
                {okText || t("ok")}
              </Button>
            )}
          </>
        }
        open={open}
        afterClose={() => onColseModal?.()}
        onCancel={() => setOpen(false)}
        destroyOnClose
        closeIcon={
          <CloseOutlined
            className="text-[#000000d9] dark:text-[#ffffff73]"
            style={{ fontSize: 24 }}
          />
        }
      >
        {isProForm ? (
          <ProForm
            layout={layout}
            form={form}
            labelCol={layout === "vertical" ? {} : { span: 8 }}
            wrapperCol={layout === "vertical" ? {} : { span: 12 }}
            submitter={false}
            onFinish={async (values) => {
              if (!request) {
                onClick?.(form?.getFieldsValue(), (isOpen) => {
                  setOpen(isOpen);
                });
                return;
              }
              setLoading(true);
              try {
                await request({ ...otherParams, ...values });
                setLoading(false);
                message.success("Success!", 2.5);
                setOpen(false);
                onColseModal?.();
                onClick?.(values);
              } catch (error: any) {
                setLoading(false);
                message.error(error || "Fail!", 2.5);
              }
            }}
          >
            <div className="p-4 pb-0">{children}</div>
          </ProForm>
        ) : (
          <div className="px-4">{children}</div>
        )}
      </Modal>
    </>
  );
};

export default CustomModal;
